import React from "react";
import styled from "styled-components";

import { DataTypes } from "../../../../rule-engine-core/Common/Data/DataTypes";
import { DataUtilities } from "../../../../rule-engine-core/Common/DataUtilities";

import { DataEditControl } from "../../../../CommonUI/DataEditing/DataEditControl";

import { ObserveMultiState } from "../../../../CommonUI/StateManagement/ObserveMultiState";
import { ObserveState } from "../../../../CommonUI/StateManagement/ObserveState";
import { StateManager } from "../../../../rule-engine-core/Common/StateManager";

import { TableColumn } from "../../../../rule-engine-core/Rule/Table/Common/TableColumn";

import { ValueTableConfiguration } from "../../../../rule-engine-core/Rule/Table/Value/ValueTableConfiguration";

import { ValueTableRuleEditContext } from "../../../../rule-engine-core/Rule/Table/Value/ValueTableRuleEditContext";

import { Error } from "../../CommonUI/Error";
import {
    ITableRowTestValue,
    TableRowTestContext,
} from "../../../../rule-engine-core/Rule/Table/Common/TableRowTestContext";
import { UIStyleConstants } from "../../../../rule-engine-core/Common/UIStyleConstants";

interface IValueTableRuleCell {
    editContext: ValueTableRuleEditContext;
    resultColumn: TableColumn;
    ruleDefinition: ValueTableConfiguration;
}

export const ValueTableResultDefaultCell = (props: IValueTableRuleCell) => {
    const { editContext, resultColumn, ruleDefinition } = props;

    const defaultResult = ruleDefinition.getDefaultResultByColumnId(resultColumn._id);

    if (!defaultResult) return null;

    const onSelect = () => {
        editContext.selectedCell = defaultResult;
    };

    return (
        <TableRowTestContext.Consumer>
            {(value) => (
                <ObserveMultiState
                    listenTo={[defaultResult, resultColumn]}
                    control={() => {
                        return (
                            <ObserveState
                                listenTo={editContext}
                                properties={["selectedCell"]}
                                control={() => {
                                    let selected = editContext.selectedCell === defaultResult;
                                    let issues = defaultResult.validateCellData(
                                        ruleDefinition.getResultColumnType(resultColumn) ||
                                            DataUtilities.createDataByType(resultColumn.dataType!, resultColumn.name),
                                    );

                                    return (
                                        <DefaultResultCellRender
                                            data-testid={`column_${resultColumn._id}`}
                                            selected={selected}
                                            onClick={onSelect}
                                            testValue={value}
                                        >
                                            <DataEditControl
                                                forData={
                                                    ruleDefinition.getResultColumnType(resultColumn) ||
                                                    DataUtilities.createDataByType(
                                                        resultColumn.dataType!,
                                                        resultColumn.name,
                                                    )
                                                }
                                                value={defaultResult.value}
                                                mode={
                                                    resultColumn.dataType === DataTypes.FILE
                                                        ? "display_mode_edit"
                                                        : selected
                                                          ? "edit_mode"
                                                          : "display_mode"
                                                }
                                                navigate={editContext.navigate}
                                                onUpdate={(newValue) => {
                                                    defaultResult.value = newValue;
                                                    StateManager.propertyChanged(defaultResult, "values");
                                                    StateManager.changed(ruleDefinition);
                                                }}
                                                // navigate={navigate}
                                                editMode={resultColumn.dataType === DataTypes.FILE ? "layer" : "inline"}
                                            />

                                            <Error issues={issues} />
                                        </DefaultResultCellRender>
                                    );
                                }}
                            />
                        );
                    }}
                />
            )}
        </TableRowTestContext.Consumer>
    );
};

const DefaultResultCellRender = styled.div<{ selected: boolean; testValue?: ITableRowTestValue }>`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;

    background: ${UIStyleConstants.WHITE_COLOR};
    border-radius: 2px;
    position: relative;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: left;

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    ${(props) =>
        props.selected
            ? `border: 1px solid ${UIStyleConstants.BLUE_GRAY_COLOR}`
            : `border: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR}`};

    .ValueEditor-root {
        width: 100%;
        padding: 6px 4px;

        .ValueEditor-display {
            padding: 6px 12px;

            ${(props) =>
                props.testValue === ITableRowTestValue.PASSED
                    ? ` color: ${UIStyleConstants.GREEN_COLOR};`
                    : props.testValue === ITableRowTestValue.FAILED
                      ? `
                        color: ${UIStyleConstants.RED_COLOR};
                        text-decoration: line-through;
                    `
                      : ``}
        }
    }

    .edit-button {
        opacity: 0;
    }

    &:hover {
        .edit-button {
            opacity: 1;
        }
    }
`;
